import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0188',
    ecrans: ['00-2'],
    params: [
        'parvue'
    ]
});
